module.exports = "pegasus/assets/blocks/image-3-theme4.png";